import React, { Dispatch, SetStateAction } from 'react'

// ** MUI Imports
import { Button } from '@mui/material'
import { Magnify } from 'mdi-material-ui'

// ** Util Imports
import _ from 'lodash'

// ** Child Imports
import InputTextField from 'src/components/common/form-elements/InputTextField'

interface SearchAsYouTypeProps {
  setSearchedText?: Dispatch<SetStateAction<string>>
  // searchType?: SearchType
  isReadOnly?: boolean
  autoFocus?: boolean
  hideBrowseButton?: boolean
  formErrors?: any
  errorStatus?: boolean
  handleClick?: any
  label?: string
  placeholder: string
  resetErrorState?: any
  browseText?: string
  startAdornment?: React.ReactNode
}

const SearchAsYouType: React.FC<SearchAsYouTypeProps> = ({
  setSearchedText,
  // searchType,
  isReadOnly = false,
  autoFocus = false,
  hideBrowseButton = false,
  formErrors,
  errorStatus,
  handleClick,
  label,
  placeholder,
  resetErrorState,
  browseText = 'Browse',
  startAdornment
}) => {
  const handleChange = _.debounce(async (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchedText && setSearchedText(encodeURIComponent(event.target.value))
  }, 500)

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        gap: 10
      }}
    >
      <InputTextField
        textFieldId='catalogue-search'
        label={label}
        endIcon={<Magnify />}
        {...(handleClick ? { handleOnClick: handleClick } : {})}
        handleChange={handleChange}
        inputPlaceholder={placeholder}
        inputProps={{ readOnly: isReadOnly }}
        autoFocus={autoFocus}
        isFullWidth={true}
        {...(resetErrorState ? { handleFocus: resetErrorState } : {})}
        {...(startAdornment ? { startIcon: startAdornment } : {})}
      />
      {!Boolean(hideBrowseButton) ? (
        <Button variant='outlined' size='medium' sx={{ marginTop: errorStatus ? 0 : 5 }} onClick={handleClick}>
          {browseText}
        </Button>
      ) : (
        <></>
      )}
    </div>
  )
}

export default SearchAsYouType
